import {BaseView} from '../core/view'
import slick from "slick-carousel"

export default BaseView.extend({

    el: '.js-product-detail',

    slider: undefined,

    events: {
        'click .js-product-detail-slider--next': 'onClickNextSlide',
        'click .js-product-detail-slider--prev': 'onClickPrevSlide',
        'click .js-product-detail-thumbnail': 'onClickChangeProductDetailImage'
    },

    initialize: function () {
        this.loadSlickSlider();
    },

    loadSlickSlider: function () {
        this.slider = this.$el.find('.js-product-detail-slider').slick({
            dots: window.innerWidth < 568,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
        });

        this.slider.on('afterChange', this.highlightThumbnail);
    },

    changeSliderImage: function (sliderIndex) {
        this.slider.slick('slickGoTo', sliderIndex);
    },

    onClickNextSlide: function (e) {
        e.stopPropagation();
        this.slider.slick('slickNext');
    },

    onClickPrevSlide: function (e) {
        e.stopPropagation();
        this.slider.slick('slickPrev');
    },

    onClickChangeProductDetailImage: function(e){
        const elem = e.currentTarget;
        if(!elem.classList.contains('product-detail__slider-thumbs__container--active')){
            document.querySelector('.product-detail__slider-thumbs__container--active').classList.remove('product-detail__slider-thumbs__container--active');
            elem.classList.add('product-detail__slider-thumbs__container--active');
        }
        const sliderIndex = elem.getAttribute('data-img');

        this.changeSliderImage(sliderIndex - 1);
    },

    highlightThumbnail: function(e, slick, current){
        const currentThumbnail = document.querySelector('.product-detail__slider-thumbs__container--active');
        const gallery = currentThumbnail.parentNode.children;

        currentThumbnail.classList.remove('product-detail__slider-thumbs__container--active');
        gallery[current].classList.add('product-detail__slider-thumbs__container--active');
    }
});
